import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ContainerPositionDto } from 'src/shared/service-proxies/service-proxies';

export class PopupDropDownListItem {
  constructor(id?: string, name?: string) {
    this.id = id,
    this.name = name;
  }

  id: string;
  name: string;
}

@Component({
    selector: 'app-containers-popup',
    templateUrl: './containers-popup.component.html',
    styleUrls: ['./containers-popup.component.scss'],
    standalone: false
})
export class ContainersPopupComponent {
  @Input() imageSrc: string | null = null;
  @Input() selectedId: string | null = null;
  @Input() containers: ContainerPositionDto[] | null = null;
  @Input() isOpen: boolean = false;
  @Output() close = new EventEmitter<void>();

  // Private variables
  selectedAsset: ContainerPositionDto | null = null;

  ngOnChanges(changes) {
    this.setSelectedAsset(this.selectedId);
  }

  ngOnInit(): void {
    this.setSelectedAsset(this.selectedId);
  }

  ngAfterViewInit() {
    this.setSelectedAsset(this.selectedId);
  }

  closePopup(): void {
    this.close.emit();
  }

  onAssetChange(event: any): void {
    this.setSelectedAsset(event.value);
  }

  setSelectedAsset(assetId: string) {
    if (assetId) {
      const matchedContainer = this.containers.find(
        container => container.containerName === assetId
      );

      if (matchedContainer) {
        this.selectedAsset = matchedContainer;
      }
    }
  }
}
